import React, { useState, useEffect, useRef } from "react";
import "../style.scss";
import "./style.scss";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
// const Recaptcha = require("react-recaptcha");
import {
  investorawareness,
  learnInvestorFaqs,
  // getStateCityList,
  // postSebiRegister,
  getIapDocuments,
  getIapDownloadsSearch,
  getkeyKnowInfo,
  cornerSectionOverview,
  getIAPDownloadsMonthsCorner,
  getMfBytesMetaData,
} from "../actions";
import "react-tabs/style/react-tabs.scss";
import {
  getRouting,
  formDataGenerator,
  getLang,
} from "../../../../../utils/common";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import Modal from "react-modal";
import Slider from "react-slick";
import RegisterModel from "./registerModel";

const InvestorAwarenessProgram = (props) => {
  const {
    getMfBytesMetaData,
    mfbyesmetaData,
    investorawareness,
    investmentAwarenessList,
    learnInvestorFaqs,
    investmentAwarenessFaqs,
    // getStateCityList,
    // postSebiRegister,
    // investorawarenessSatate,
    getIapDocuments,
    learnCornerIAP,
    getIapDownloadsSearch,
    learnCornerIAPSearch,
    getkeyKnowInfo,
    cornerKeyKnow,
    cornerSectionOverview,
    cornerOverviewList,
    getIAPDownloadsMonthsCorner,
    cornerIapMonthValue,
    location: { pathname },
  } = props;

  const getCurrent = (nc) => {
    switch (nc) {
      case "iap-downloads":
        return 0;
      case "investor-awareness-programmes":
        return 1;
      case "kyc-redressal-complaints":
        return 2;
      case "mf-bytes-app":
        return 3;
      default:
        return 0;
    }
  };

  const current = pathname.split("/")[3];
  const [learnCornerType, setlearnCornerType] = useState(current);
  const [selectedIndexTab, setSelectedIndexTab] = useState(getCurrent(current));
  const [bradeCrump, setBradeCrump] = useState();
  const [faqsRefreshersearch, setFaqsRefreshersearch] = useState();
  const [investerAwarenessCornerList, setinvesterAwarenessCornerList] =
    useState();
  const [investerCornerFaqs, setinvesterCornerFaqs] = useState();
  // const [getselectStatedata, setgetselectStatedata] = useState();
  // const [captchaToken, setCaptchaToken] = useState();
  const [iapList, setiapList] = useState("");
  const [iapYear, setiapYear] = useState("");
  const [iapYearList, setiapYearList] = useState("");
  const [iapMonth, setiapMonth] = useState("");
  const [iapMonthList, setiapMonthList] = useState("");
  const [iapSearchValue, setiapSearchValue] = useState("");
  const [cornerOverviewTab, setcornerOverviewTab] = useState("");
  const [metaData, setMetaData] = useState("");
  const [flag, setFlag] = useState(false);
  const [latestIapYearMonth, setlatestIapYearMonth] = useState({
    year:'',
    month:''
  });
  const [latestIapYearCheck, setlatestIapYearCheck] = useState(true);
  const [latestIapMonthCheck, setlatestIapMonthCheck] = useState(true);

  useEffect(()=>{
    if(flag == true){
      setFlag(false);
    }
  },[flag]);

  useEffect(() => {
    if (iapYear == "") {
      if (
        learnCornerIAP &&
        learnCornerIAP.cornerIapDocuments &&
        learnCornerIAP.cornerIapDocuments.Years &&
        learnCornerIAP.cornerIapDocuments.Years.values &&
        learnCornerIAP.cornerIapDocuments.Years.values[0] &&
        learnCornerIAP.cornerIapDocuments.Years.values[0].value
      ) {
        setiapYear(learnCornerIAP.cornerIapDocuments.Years.values[0].value);
        if(latestIapYearCheck){
          setlatestIapYearMonth({...latestIapYearMonth,year:learnCornerIAP.cornerIapDocuments.Years.values[0].value});
          setlatestIapYearCheck(false);
        }
      }
    }
  }, [learnCornerIAP]);

  useEffect(() => {
    if (iapMonth == "") {
      if (
        cornerIapMonthValue &&
        cornerIapMonthValue.iapMonthDefault &&
        cornerIapMonthValue.iapMonthDefault.latestMonth
      ) {
        setiapMonth(cornerIapMonthValue.iapMonthDefault.latestMonth);
        if(latestIapMonthCheck){
          setlatestIapYearMonth({...latestIapYearMonth,month:cornerIapMonthValue.iapMonthDefault.latestMonth});
          setlatestIapMonthCheck(false);
        }
      }
    }
  }, [cornerIapMonthValue]);

  useEffect(() => {
    if (current) {
      setlearnCornerType(current);
    }
  }, [current]);

  useEffect(() => {
    if (learnCornerType === "iap-downloads") {
      setSelectedIndexTab(0);
      setBradeCrump("IAP Downlods");
    }
    if (learnCornerType === "investor-awareness-programmes") {
      setSelectedIndexTab(1);
      setBradeCrump("Investor Awareness programmes");
    }
    if (learnCornerType === "kyc-redressal-complaints") {
      setSelectedIndexTab(2);
      setBradeCrump("KYC & Redressal of Complaints");
    }
    if (learnCornerType === "mf-bytes-app") {
      setSelectedIndexTab(3);
      setBradeCrump("MF Bytes App");
    }
  }, [learnCornerType]);

  // useEffect(() => {
  //   getStateCityList(getLang());
  // }, []);

  useEffect(() => {
    if(learnCornerType === "kyc-redressal-complaints"){
      !(cornerKeyKnow && cornerKeyKnow.cornerKYC && cornerKeyKnow.cornerKYC.body) && getkeyKnowInfo();
    }
  }, [learnCornerType]);

  useEffect(() => {
    if (
      learnCornerType === "iap-downloads" &&
      learnCornerIAP &&
      learnCornerIAP.cornerIapDocuments &&
      learnCornerIAP.cornerIapDocuments.meta
    ) {
      setMetaData(learnCornerIAP.cornerIapDocuments.meta);
    }
    if (
      learnCornerType === "investor-awareness-programmes" &&
      investmentAwarenessList &&
      investmentAwarenessList.investerAwarenessList &&
      investmentAwarenessList.investerAwarenessList.meta
    ) {
      setMetaData(investmentAwarenessList.investerAwarenessList.meta);
    }
    if (
      learnCornerType === "kyc-redressal-complaints" &&
      cornerKeyKnow &&
      cornerKeyKnow.cornerKYC &&
      cornerKeyKnow.cornerKYC.meta
    ) {
      setMetaData(cornerKeyKnow.cornerKYC.meta);
    }
    if (
      learnCornerType === "mf-bytes-app" &&
      mfbyesmetaData &&
      mfbyesmetaData.meta
    ) {
      setMetaData(mfbyesmetaData.meta);
    }
  }, [learnCornerType, investmentAwarenessList, cornerKeyKnow, mfbyesmetaData]);

  useEffect(() => {
    !(cornerOverviewList && cornerOverviewList.cornerOverview) && cornerSectionOverview();
  }, []);

  useEffect(() => {
    if (learnCornerType === "mf-bytes-app") {
      !(mfbyesmetaData && mfbyesmetaData.meta && flag == false) && getMfBytesMetaData();
    }
  }, [learnCornerType]);

  useEffect(() => {
    if (learnCornerType === "investor-awareness-programmes") {
      !(investmentAwarenessList && investmentAwarenessList.investerAwarenessList && investmentAwarenessList.investerAwarenessList.awareness_program && flag == false) && investorawareness(getLang());

      let params = {
        search: faqsRefreshersearch ? faqsRefreshersearch : "",
      };
      !(investmentAwarenessFaqs && investmentAwarenessFaqs.investerAwarenessFaqs && investmentAwarenessFaqs.investerAwarenessFaqs.faqs && flag == false) && learnInvestorFaqs(formDataGenerator(params));
    }
  }, [learnCornerType, faqsRefreshersearch]);

  useEffect(() => {
    if (
      investmentAwarenessList &&
      investmentAwarenessList.investerAwarenessList
    ) {
      setinvesterAwarenessCornerList(
        investmentAwarenessList.investerAwarenessList
      );
    }
  }, [investmentAwarenessList]);

  useEffect(() => {
    if (
      investmentAwarenessFaqs &&
      investmentAwarenessFaqs.investerAwarenessFaqs &&
      investmentAwarenessFaqs.investerAwarenessFaqs.faqs
    ) {
      setinvesterCornerFaqs(investmentAwarenessFaqs.investerAwarenessFaqs.faqs);
    }
  }, [investmentAwarenessFaqs]);

  useEffect(() => {
    if (cornerOverviewList && cornerOverviewList.cornerOverview) {
      setcornerOverviewTab(cornerOverviewList.cornerOverview);
    }
  }, [cornerOverviewList]);

  useEffect(() => {
    if (learnCornerType === "iap-downloads") {
      let params = {
        year: "",
        month: "",
      };
      !(learnCornerIAP && learnCornerIAP.cornerIapDocuments && flag == false) && getIapDocuments(formDataGenerator(params));
    }
  }, [learnCornerType]);

  useEffect(() => {
    if (learnCornerType === "iap-downloads" && (iapYear && iapYear.toString().length > 0) && (iapMonth && iapMonth.toString().length > 0)) {
      let params = {
        year: iapYear ? iapYear : "",
        month: iapMonth ? iapMonth : "",
      };

      getIapDocuments(formDataGenerator(params));
    }
  }, [iapYear, iapMonth, learnCornerType]);

  useEffect(() => {
    if (learnCornerType === "iap-downloads") {
      if(iapYear && iapYear.toString().length > 0){
        let params = {
          year: iapYear ? iapYear : "",
        };
        getIAPDownloadsMonthsCorner(formDataGenerator(params));
      }
    }
  }, [iapYear, learnCornerType]);

  useEffect(() => {
    if (learnCornerIAP && learnCornerIAP.cornerIapDocuments) {
      setiapList(learnCornerIAP.cornerIapDocuments);
    }
    if(learnCornerIAP &&
      learnCornerIAP.cornerIapDocuments &&
      learnCornerIAP.cornerIapDocuments.Years &&
      learnCornerIAP.cornerIapDocuments.Years.values){
      setiapYearList(learnCornerIAP.cornerIapDocuments.Years.values);
    }
    if(learnCornerIAP &&
      learnCornerIAP.cornerIapDocuments &&
      learnCornerIAP.cornerIapDocuments.Months &&
      learnCornerIAP.cornerIapDocuments.Months.values){
      setiapMonthList(learnCornerIAP.cornerIapDocuments.Months.values);
    }
  }, [learnCornerIAP]);

  const handleYearIAP = (e) => {
    setiapYear(e);
    setiapMonth("");
  };

  const handleMonthIAP = (e) => {
    setiapMonth(e);
  };

  const handleIAPSearch = async (e) => {
    let params = {
      year: iapYear ? iapYear : "",
      month: iapMonth ? iapMonth : "",
      search: e.target.value ? e.target.value : "",
    };
    setiapSearchValue(e.target.value);
    if (e.target.value !== "") {
      getIapDownloadsSearch(formDataGenerator(params));
    }else{
      getIapDocuments(formDataGenerator(params));
    }
  };

  const handleSearchFilter = (e) => {
    setFaqsRefreshersearch(e.target.value);
    setFlag(true);
  };

  const [filterShow, setfilterShow] = useState(false);
  const handleClosefilter = () => setfilterShow(false);
  const handleShowfilter = () => setfilterShow(true);

  const handleClearFilter = async () => {
    setiapSearchValue("");
    let params = {
      year: latestIapYearMonth.year,
      month: latestIapYearMonth.month,
    };
    getIapDocuments(formDataGenerator(params));
  };

  const handleFilter = async () => {
    setfilterShow(false);
    setiapSearchValue("");
  };

  const handleApiCall = async (e, tabName) => {
    setlearnCornerType(tabName);
    setiapMonth("");
    setFaqsRefreshersearch();
    setFlag(true);
  };

  //dropdown start

  const [dropdown, setdropdown] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropDown = () => {
    setdropdown(!dropdown);
  };

  const handleClickOut = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setdropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOut);
    return () => {
      document.removeEventListener("click", handleClickOut);
    };
  }, [dropdown]);

  //dropdown end

  //tryacord start
  const [selected, setSelected] = useState(null);
  const toggle = (index) => {
    if (selected === index) {
      return setSelected(null);
    }
    setSelected(index);
  };

  //tryacord end

  //modals start

  const [isOpenModel, setIsOpenModel] = useState(false);

  const openModal = () => {
    setIsOpenModel(true);
  };

  const closeModal = () => {
    setIsOpenModel(false);
  };

  //modals end

  //Carousal start

  const settings = {
    autoplay: true,
    infinite: true,
    speed: 100,
    slidesToShow: 1,
  };
  //Carousal end

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://www.google.com/recaptcha/api.js';
    script.defer = true; // Set defer attribute
    
    document.body.appendChild(script);


    // Cleanup function to remove script when component unmounts or location changes
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="wrapper">
      {metaData && metaData !== null && (
        <Helmet>
          <title>{metaData.title ? metaData.title : ""}</title>
          <meta
            name="description"
            content={metaData.description ? metaData.description : ""}
          />
          <meta
            name="keywords"
            content={metaData.keywords ? metaData.keywords : ""}
          />
          <meta
            property="og:title"
            content={metaData.og_title ? metaData.og_title : ""}
          />
          <meta
            property="og:description"
            content={metaData.og_description ? metaData.og_description : ""}
          />
          <meta
            property="og:image"
            content={metaData.og_image ? metaData.og_image : ""}
          />
          <meta
            property="og:url"
            content={metaData.og_url ? metaData.og_url : ""}
          />
        </Helmet>
      )}

      <section className="aboutHead">
        <div className="container">
          <div className="d-flex dropdowncls" ref={dropdownRef}>
            <div class="dropdown me-auto">
              <div
                id="dropdownMenuLink"
                // data-bs-toggle="dropdown"
                // aria-expanded="false"
                onClick={toggleDropDown}
              >
                <h1>
                  <span>Investor</span> Awareness Program
                  <img
                    className="ms-2"
                    src="/images/New/redDownArrow.svg"
                    alt="red-downward-arrow"
                  />
                </h1>
              </div>
              {dropdown && (
                <ul class="dropdown-body" aria-labelledby="dropdownMenuLink">
                  {cornerOverviewTab &&
                    cornerOverviewTab.length > 0 &&
                    cornerOverviewTab.map((over, index) =>
                      over.linkName != "Investor Awareness Program" ? (
                        <li>
                          <a
                            class="dropdown-item fw-bold"
                            href={over.linkName=='Quiz' ? over.linkUrl : over.routeConstant}
                          >
                            {over.linkName}
                          </a>
                        </li>
                      ) : null
                    )}
                </ul>
              )}
            </div>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active breadcolor">
                  <a href="/learners-corner">Learners’ Corner</a>
                </li>
                {/* <li
                  className="breadcrumb-item active breadcolor"
                  aria-current="page"
                >
                  {bradeCrump}
                </li> */}
              </ol>
            </nav>
          </div>
        </div>
      </section>

      <section>
        <div className="container ctab">
          <div className="mrg_40">
            <Tabs className="customTab mt-4" selectedIndex={selectedIndexTab}>
              <TabList className="myClass slickOptions">
                <Link
                  to={getRouting(
                    "/learners-corner/investor-awareness/iap-downloads",
                    "IAP Downloads"
                  )}
                >
                  <Tab
                    onClick={async (e) => {
                      setBradeCrump("IAP Downloads");
                      await handleApiCall(e, "iap-downloads");
                    }}
                    tabFor="0"
                    value={0}
                  >
                    <div>
                      <p>IAP Downlods</p>
                    </div>
                  </Tab>
                </Link>
                <Link
                  to={getRouting(
                    "/learners-corner/investor-awareness/investor-awareness-programmes",
                    "Investor Awareness programmes"
                  )}
                >
                  <Tab
                    onClick={async (e) => {
                      setBradeCrump("Investor Awareness programmes");
                      await handleApiCall(e, "investor-awareness-programmes");
                    }}
                    tabFor="1"
                    value={1}
                  >
                    <div>
                      <p>Investor Awareness programmes</p>
                    </div>
                  </Tab>
                </Link>
                <Link
                  to={getRouting(
                    "/learners-corner/investor-awareness/kyc-redressal-complaints",
                    "KYC & Redressal of Complaints"
                  )}
                >
                  <Tab
                    onClick={async (e) => {
                      setBradeCrump("KYC & Redressal of Complaints");
                      await handleApiCall(e, "kyc-redressal-complaints");
                    }}
                    tabFor="2"
                    value={2}
                  >
                    <div>
                      <p>KYC & Redressal of Complaints</p>
                    </div>
                  </Tab>
                </Link>
                <Link
                  to={getRouting(
                    "/learners-corner/investor-awareness/mf-bytes-app",
                    "MF Bytes App"
                  )}
                >
                  <Tab
                    onClick={async (e) => {
                      setBradeCrump("MF Bytes App");
                      await handleApiCall(e, "mf-bytes-app");
                    }}
                    tabFor="3"
                    value={3}
                  >
                    <div>
                      <p>MF Bytes App</p>
                    </div>
                  </Tab>
                </Link>
              </TabList>
              <TabPanel>
                <section className="mt-4">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div class="input-group inputsearch w-25">
                      <span class="input-group-text" id="basic-addon2">
                        <img src="/images/New/grey-search.svg" />
                      </span>
                      <input
                        type="text"
                        class="form-control ps-0"
                        placeholder="Search..."
                        aria-label="Search..."
                        aria-describedby="basic-addon2"
                        onChange={handleIAPSearch}
                        value={iapSearchValue}
                      />
                      
                    </div>
                    <div
                      className="d-flex filter-border align-self-center ms-3"
                      onClick={handleShowfilter}
                    >
                      <img src="/images/New/filter-red.svg" />
                      <p className="filter-text d-none d-md-block">Filter</p>
                    </div>
                  </div>

                  <div>
                    <div className="row my-4">
                      {iapList &&
                        iapList.iapDownloadsDocuments &&
                        iapList.iapDownloadsDocuments.length > 0 &&
                        iapList.iapDownloadsDocuments.map((item) => (
                          <div className="col-md-12">
                            <a
                              href={item && item.file && item.file.url}
                              target="_blank"
                            >
                              <div className="bgw d-flex justify-content-between align-items-center p-3 mx-0 mb-3">
                                <div className="d-flex align-items-center">
                                  <img src="/images/New/pdf.png" alt="pdf-document-icon" />
                                  <h2 className="text ms-2">
                                    {item.title ? item.title : ""}
                                  </h2>
                                </div>
                                <div className="d-flex justify-content-end sidearrow">
                                  <img src="/images/New/redarrow.svg" alt="red-arrow-icon" />
                                </div>
                              </div>
                            </a>
                          </div>
                        ))}
                    </div>
                  </div>
                </section>
              </TabPanel>
              <TabPanel>
                <div className="InvestingRefreshers awareness">
                  <div className="my-5">
                    <img
                      className="img-fluid bannerimg"
                      src={
                        investerAwarenessCornerList &&
                        investerAwarenessCornerList.banner &&
                        investerAwarenessCornerList.banner.image &&
                        investerAwarenessCornerList.banner.image.url
                      }
                    />
                    <div className="row">
                      <div className="col-md-8">
                        <h2 className="mt-4 mb-3 sebicls">
                          {investerAwarenessCornerList &&
                            investerAwarenessCornerList.banner &&
                            investerAwarenessCornerList.banner.heading}
                        </h2>
                        <p className="text-justify">
                          {investerAwarenessCornerList &&
                            investerAwarenessCornerList.banner &&
                            investerAwarenessCornerList.banner.body_text}
                        </p>
                      </div>
                      <div className="col-md-7">
                        <div className="bgw p-3 d-flex align-items-center justify-content-between registercls mt-4">
                          <p>
                            {investerAwarenessCornerList &&
                              investerAwarenessCornerList.banner &&
                              investerAwarenessCornerList.banner.first_text}
                          </p>
                          <div className="btn btn-primary" onClick={openModal}>
                            Register
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* modal start */}
                    <RegisterModel open={isOpenModel} onClose={closeModal} />
                    {/* modal end */}

                    <div className="mrg_40">
                      <div className="clearFix"></div>
                      <h3 className="mt-md-5 mt-4 scheduled">
                        Scheduled for Investor Awareness Programme
                      </h3>
                      <div className="row my-4">
                        {investerAwarenessCornerList &&
                          investerAwarenessCornerList.awareness_program &&
                          investerAwarenessCornerList.awareness_program
                            .content &&
                          investerAwarenessCornerList.awareness_program.content
                            .length > 0 &&
                          investerAwarenessCornerList.awareness_program.content.map(
                            (item) => (
                              <div className="col-md-12">
                                <a
                                  href={item.file && item.file.url}
                                  target="_blank"
                                >
                                  <div className="bgw d-flex justify-content-between align-items-center p-3 mx-0 mb-3">
                                    <div className="d-flex align-items-center">
                                      <img src="/images/New/pdf.png" alt="pdf-document-icon" />
                                      <h2 className="text ms-2">
                                        {item.title ? item.title : ""}
                                      </h2>
                                    </div>
                                    <div className="d-flex justify-content-end sidearrow">
                                      <img src="/images/New/redarrow.svg" alt="red-arrow-icon" />
                                    </div>
                                  </div>
                                </a>
                              </div>
                            )
                          )}
                      </div>
                    </div>
                    <div className="custAccordian pb-5">
                      <h3 className="mt-md-4 mb-4 scheduled">FAQ’s</h3>
                      <div className="row">
                        <div className="col-md-8 mb-4">
                          <div className="input-group faqgroup mb-3">
                            <span
                              className="input-group-text serchcolor"
                              id="inputGroup-sizing-default"
                            >
                              <img
                                className="search"
                                src="/images/New/grey-search.svg"
                                alt=""
                              />
                            </span>
                            <input
                              type="text"
                              className="form-control searchb ps-0 py-3"
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-default"
                              placeholder="Search by Name..."
                              onChange={handleSearchFilter}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="accordian awarenessacord">
                        {investerCornerFaqs &&
                          investerCornerFaqs.length > 0 &&
                          investerCornerFaqs.map((item, index) => (
                            <>
                              <div className="item">
                                <div
                                  className="title"
                                  onClick={() => toggle(index)}
                                >
                                  <h2 className="ms-3">
                                    {item.title ? item.title : ""}
                                  </h2>

                                  <div>
                                    <img
                                      className={
                                        selected === index ? "rotate" : ""
                                      }
                                      src="/images/New/redDownArrow.svg"
                                    />
                                  </div>
                                </div>
                                <div
                                  className={
                                    selected === index
                                      ? "content show"
                                      : "content"
                                  }
                                >
                                  {item.body ? (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item.body,
                                      }}
                                    />
                                  ) : null}
                                </div>
                              </div>
                            </>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                {cornerKeyKnow &&
                cornerKeyKnow.cornerKYC &&
                cornerKeyKnow.cornerKYC.body ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: cornerKeyKnow.cornerKYC.body,
                    }}
                  />
                ) : null}
              </TabPanel>
              <TabPanel>
                <div className="mfbytes">
                  <div className="">
                    <div className="row justify-content-center">
                      <div className="col-md-12 mt-5 mb-3 mfbyteshead p-5">
                        <div className="row align-items-center">
                          <div className="col-md-6">
                            <h2
                              className="mb-3 fs-2"
                              style={{ color: "#333333" }}
                            >
                              HDFC MFBytes makes learning fun & simple!
                            </h2>
                            <p className="mb-4">
                              Learn about Mutual Fund investments on-the-go with
                              this interactive and informative app.
                            </p>
                            <div className="d-flex">
                              <a
                                className="playStoreButton"
                                href="https://play.google.com/store/apps/details?id=com.enparadigm.mfbytes"
                              >
                                <img
                                  className="playStoreImg img-fluid"
                                  src="/images/play_store_img.svg"
                                  alt="google-play-store-icon"
                                />
                              </a>
                              <a
                                className="appStoreButton ms-3"
                                href=" https://apps.apple.com/in/app/mfbytes/id1489728704\ "
                              >
                                <img
                                  className="appStoreImg img-fluid"
                                  src="/images/app_store_img.svg"
                                  alt="download-on-the-app-store-icon"
                                />
                              </a>
                            </div>
                            <p className="mt-3">Available on Android & iOS</p>
                          </div>
                          <div className="col-md-6">
                            <Slider {...settings}>
                              <div>
                                <img
                                  className="d-block w-100"
                                  src="https://hdfcmf-website-dev.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/mf-bytes/MF-Bytes-1.svg"
                                  alt="First slide"
                                />
                              </div>
                              <div>
                                <img
                                  className="d-block w-100"
                                  src="https://hdfcmf-website-dev.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/mf-bytes/MF-Bytes-2.svg"
                                  alt="Second slide"
                                />
                              </div>
                              <div>
                                <img
                                  className="d-block w-100"
                                  src="https://hdfcmf-website-dev.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/mf-bytes/MF-Bytes-4.svg"
                                  alt="Third slide"
                                />
                              </div>
                              <div>
                                <img
                                  className="d-block w-100"
                                  src="https://hdfcmf-website-dev.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/mf-bytes/MF-Bytes-5.svg"
                                  alt="Third slide"
                                />
                              </div>
                            </Slider>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 mfbyteshead p-5">
                        <div className="d-flex mfbytediv">
                          <div>
                            <img
                              className="mfBytesImg"
                              src="https://hdfcmf-website-dev.s3.ap-south-1.amazonaws.com/s3fs-public/new-website-images/mf-bytes/MF-Bytes-idea.svg"
                              alt="mf-bytes-idea-icon"
                            />
                          </div>
                          <div class="ms-2 mfbytedesc">
                            <span className="fw-bold mb-2 fs-4">MFBytes</span>
                            <p className="fs-4 fw-bold mfbytesp mb-4">
                              Things you can learn through the app
                            </p>
                          </div>
                        </div>
                        <div className="ms-5 mfbytepara">
                          <div>
                            <ul className="mainmfbyte">
                              <li className="mfbyteswidth">Why invest</li>
                              <li className="mfbyteswidth">Why mutual funds</li>
                              <li className="mfbyteswidth">
                                How to invest through mutual funds
                              </li>
                              <li className="mfbyteswidth">
                                Goal based investing
                              </li>
                              <li className="mfbyteswidth">How to save tax</li>
                              <li className="mfbyteswidth">
                                Understanding risk
                              </li>
                              <li className="mfbyteswidth">
                                Investment concepts
                              </li>
                              <li className="mfbyteswidth">Smart investing</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="">
                    <div className="row justify-content-center">
                      <div className="col-md-12 d-md-flex justify-content-between mb-5">
                        <div className="gray mt-4">
                          <span>
                            For KYC, change of address, investor complaints
                            redressal, etc. visit -
                            <a
                              className="gray"
                              href="https://www.hdfcfund.com/information/key-know-how"
                            >
                              https://www.hdfcfund.com/information/key-know-how
                            </a>
                          </span>
                        </div>
                        <div className="d-flex mt-4">
                          <img
                            className=""
                            src="/images/initiative_logo.png"
                            alt="hdfc-initiative-logo"
                            width="100"
                            height="38"
                          />
                          <img
                            className="ms-3"
                            src="/images/hdfc_logo.png"
                            alt="hdfc-logo"
                            width="110"
                            height="45"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </section>
      <div className="filtermodal">
        <Modal
          isOpen={filterShow}
          onRequestClose={handleClosefilter}
          contentLabel="Example Modal"
          className="filterModaliap"
        >
          <div className="mediapannel h-100">
            <div className="d-flex justify-content-between w-100 align-items-center px-3 py-2">
              <p className="filtertitle">Filter</p>
              <svg width="35" height="35" viewBox="0 0 44 48" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={handleClosefilter} className="cursorp">
                <path d="M21.9998 43.6982C32.0832 43.6982 40.3332 34.9527 40.3332 24.2638C40.3332 13.5749 32.0832 4.82947 21.9998 4.82947C11.9165 4.82947 3.6665 13.5749 3.6665 24.2638C3.6665 34.9527 11.9165 43.6982 21.9998 43.6982Z" fill="#F6F6F6" />
                <path d="M16.8115 29.7638L27.1882 18.7639" stroke="#444444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M27.1882 29.7638L16.8115 18.7639" stroke="#444444" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </div>
            <div className="mediadiv">
              <Tabs>
                <TabList>
                  <Tab>
                    <p>Search by year</p>
                  </Tab>
                  <Tab>
                    <p>Select month</p>
                  </Tab>
                </TabList>
                <TabPanel>
                  <div className="panel-content">
                    {iapYearList &&
                      iapYearList.length > 0 &&
                      iapYearList.map(
                        (year, index) => {
                          return (
                            <div class="form-check">
                              <input
                                class="form-check-input d-none"
                                type="radio"
                                name="flexRadioYearDefault"
                                checked={year.value === iapYear}
                                value={iapYear}
                                id={`flexRadioDefault11${index}`}
                                onChange={() => handleYearIAP(year.value)}
                              />
                              <label
                                class="form-check-label"
                                for={`flexRadioDefault11${index}`}
                              >
                                {year.title}
                              </label>
                            </div>
                          );
                        }
                      )}
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="panel-content">
                    {iapMonthList &&
                      iapMonthList.length > 0 &&
                      iapMonthList.map(
                        (month, index) => {
                          return (
                            <div class="form-check">
                              <input
                                class="form-check-input d-none"
                                type="radio"
                                name="flexRadioMonthDefault"
                                checked={month.value === iapMonth}
                                value={iapMonth}
                                id={`flexRadioDefault${index}`}
                                onChange={() => handleMonthIAP(month.value)}
                              />
                              <label
                                class="form-check-label"
                                for={`flexRadioDefault${index}`}
                              >
                                {month.title}
                              </label>
                            </div>
                          );
                        }
                      )}
                  </div>
                </TabPanel>
              </Tabs>
              <div className="mediabtn">
                <div
                  className="btn btn-outline-primary"
                  onClick={handleClearFilter}
                >
                  Clear Filters
                </div>
                <div className="btn btn-primary" onClick={handleFilter}>
                  Apply
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  investmentAwarenessList: state.LearnsCorners,
  investmentAwarenessFaqs: state.LearnsCorners,
  // investorawarenessSatate: state.LearnsCorners.investorawarenessSatate,
  // submitRegisterResponse: state.LearnsCorners.submitRegisterResponseData,
  subscribeEmailResponse: state.LearnsCorners.subscribeEmailResponse,
  learnCornerIAP: state.LearnsCorners,
  learnCornerIAPSearch: state.LearnsCorners,
  cornerKeyKnow: state.LearnsCorners,
  cornerOverviewList: state.LearnsCorners,
  cornerIapMonthValue: state.LearnsCorners,
  mfbyesmetaData: state.LearnsCorners.mfbyesmetaData,
});

const mapDispatchToProps = (dispatch) => ({
  investorawareness: bindActionCreators(investorawareness, dispatch),
  learnInvestorFaqs: bindActionCreators(learnInvestorFaqs, dispatch),
  // getStateCityList: bindActionCreators(getStateCityList, dispatch),
  // postSebiRegister: bindActionCreators(postSebiRegister, dispatch),
  getMfBytesMetaData: bindActionCreators(getMfBytesMetaData, dispatch),
  getIapDocuments: bindActionCreators(getIapDocuments, dispatch),
  getIapDownloadsSearch: bindActionCreators(getIapDownloadsSearch, dispatch),
  getkeyKnowInfo: bindActionCreators(getkeyKnowInfo, dispatch),
  cornerSectionOverview: bindActionCreators(cornerSectionOverview, dispatch),
  getIAPDownloadsMonthsCorner: bindActionCreators(
    getIAPDownloadsMonthsCorner,
    dispatch
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvestorAwarenessProgram);
